import script from "./countersignNode.vue?vue&type=script&lang=ts&setup=true"
export * from "./countersignNode.vue?vue&type=script&lang=ts&setup=true"

import "./countersignNode.vue?vue&type=style&index=0&id=5944057f&lang=css"

const __exports__ = script;

export default __exports__